module.exports = __webpack_public_path__ + "img/mortgage.3d419406.svg";